import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import { About } from './pages/About';
import { Layout } from './components/Layout';
import Pocketbase from './pages/Pocketbase';
import RoomEntry from './pages/RoomEntry';
import Room from './pages/Room';
import { RoomProvider } from './components/RoomContext';
import Privacy from './pages/Privacy';

function App() {
  return (
    <Router>
      <RoomProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/pocketbase" element={<Pocketbase />} />
            <Route path="/room-entry" element={<RoomEntry />} />
            <Route path="/room/:roomId" element={<Room />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </Layout>
      </RoomProvider>
    </Router>
  );
}

export default App;
